import { RootState } from "../app/store";
import { useSelector } from "react-redux";

interface useTitleHook {
  setTitle: (title: string) => void;
}

export const useTitle = (): useTitleHook => {
  const portalCustomization = useSelector(
    (state: RootState) => state.portalCustomization
  );
  return {
    setTitle: (title: string): void => {
      // Don't take over the page title when embedded
      if (process.env.REACT_APP_EMBED) {
        return;
      }
      document.title = `${title} • ${portalCustomization?.publicPortalName} • CivicClerk`;
    },
  };
};

export default useTitle;
